import Typography from "@mui/material/Typography";
import React, { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import Modal from "react-modal";

// Config
import { useTranslation } from "react-i18next";
import ToastUtil from "../../components/ToastNotification/ToastUtil";
import { config } from "../../config/index";
import { getRefreshToken, getSSOAuthDetailsByToken } from "../../helpers/sso";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
const {
  API_URL,
  EBASE_URL,
  MCONNECT_URL,
  EBASE_SECRETKEY,
  SG_ELEAVE_URL,
  HRSS_ELEAVE_URL,
} = config;

const Layout = ({ children }) => {
  const { t } = useTranslation();
  // Initial State
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  const token = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : null;
  const sso_token =
    localStorage.getItem("sso_token") !== undefined
      ? localStorage.getItem("sso_token")
      : null;
  const default_site_id = localStorage.getItem("default_site_id")
    ? Number(localStorage.getItem("default_site_id"))
    : null;

  const [client, setClient] = useState(null);
  const [sites, setSites] = useState([]);
  const [activeSite, setActiveSite] = useState(null);

  const [sidebarActive, setSidebarActive] = useState(false);

  const [sidebarItems, setSidebarItems] = useState([]);

  const sidebarToggleHandler = () => setSidebarActive(!sidebarActive);

  const [cookies, setCookie] = useCookies(["maesso"]);

  const [ssoData, setSsoData] = useState([]);

  const [ssoRefreshTokenModal, setSsoRefreshTokenModal] = useState(false);

  const componentMounted = useRef(true);

  // filter SSO access on e-leave apps
  useEffect(() => {
    if (ssoData.result !== undefined) {
      if (!ssoData.result.eleave_hrss) {
        setSidebarItems(
          sidebarItems.filter((item) => item.eleave_type !== "hrss")
        );
      }
      if (!ssoData.result.eleave_sg) {
        setSidebarItems(
          sidebarItems.filter((item) => item.eleave_type !== "sg")
        );
      }
    }
  }, [ssoData]);

  // Initial Fetch
  useEffect(() => {
    const fetchClient = async () => {
      if (user) {
        if (user.site_associates && user.site_associates.length > 0) {
          const client_id = user.site_associates[0].site.client_id;
          const email = user.email;

          try {
            let url = `${API_URL}/client/${client_id}`;

            let response = await fetch(url, {
              mode: "cors",
              method: "GET",
              withCredentials: true,
              headers: {
                Authorization: token,
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json; charset=utf-8",
              },
            });

            let responseData = await response.json();

            if (response.ok) {
              let clientData = responseData.data;

              setClient(clientData);

              let sidebarItemsData = [{ title: "Home", link: "/" }];

              if (clientData.enable_smart_scheduler) {
                sidebarItemsData = [
                  ...sidebarItemsData,
                  {
                    title: "Timeclock",
                    link: "/time-clock",
                  },
                ];
              }

              if (clientData.enable_catalogue) {
                sidebarItemsData = [
                  ...sidebarItemsData,
                  {
                    title: "Catalogue",
                    link: "/catalogue",
                  },
                ];
              }

              if (clientData.enable_delivery_order) {
                sidebarItemsData = [
                  ...sidebarItemsData,
                  {
                    title: "Delivery Order",
                    link: "/delivery-order",
                  },
                ];
              }

              if (clientData.enable_leave_credits) {
                sidebarItemsData = [
                  ...sidebarItemsData,
                  {
                    title: "Leave",
                    link: "/leave",
                  },
                ];
              }

              if (clientData.enable_claims) {
                sidebarItemsData = [
                  ...sidebarItemsData,
                  {
                    title: "Claims",
                    link: "/claims",
                  },
                ];
              }

              if (clientData.enable_edocs) {
                sidebarItemsData = [
                  ...sidebarItemsData,
                  {
                    title: t("eDocs"),
                    link: "/edocs",
                  },
                ];
              }

              if (clientData.enable_communication) {
                sidebarItemsData = [
                  ...sidebarItemsData,
                  {
                    title: t("Communications"),
                    link: "/communications",
                  },
                ];
              }

              if (clientData.enable_reward) {
                sidebarItemsData = [
                  ...sidebarItemsData,
                  {
                    title: "Rewards",
                    link: "/rewards",
                  },
                ];
              }

              if (clientData.enable_event) {
                sidebarItemsData = [
                  ...sidebarItemsData,
                  {
                    title: "Events",
                    link: "/events",
                  },
                ];
              }

              // sidebarItemsData = [
              //   ...sidebarItemsData,
              //   // {
              //   //   title: 'FAQ',
              //   //   link: '/faq',
              //   // },
              // ];

              if (clientData.eleave_sso) {
                let url = `${MCONNECT_URL}/mae/associate/login`;
                try {
                  let ebaseResponse = await fetch(url, {
                    method: "POST",
                    body: JSON.stringify({
                      secret_key: EBASE_SECRETKEY,
                      email: email,
                    }),
                    headers: {
                      Accept: "application/json, text/plain, */*",
                      "Content-Type": "application/json",
                    },
                  });

                  let resEbaseData = await ebaseResponse.json();
                  if (ebaseResponse.ok && resEbaseData) {
                    await localStorage.setItem(
                      "ebaseToken",
                      resEbaseData.token
                    );
                    setCookie("maesso", resEbaseData.token, { path: "/" });

                    sidebarItemsData = [
                      ...sidebarItemsData,
                      {
                        title: "eLeave",
                        link: EBASE_URL,
                        external: true,
                      },
                    ];
                  }
                } catch (error) {}
              }

              setSidebarItems(sidebarItemsData);
            } else {
              console.log(response.message);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          ToastUtil.error(
            "You have not been assigned to any site. Please contact Administrator."
          );
        }
      } else {
        ToastUtil.error("User is undefined");
      }
    };

    const fetchSites = async () => {
      if (user) {
        if (user.site_associates && user.site_associates.length > 0) {
          const pArray = user.site_associates.map(async (siteAssociate) => {
            const client_id = siteAssociate.site.client_id;
            const site_id = siteAssociate.site_id;

            try {
              let url = `${API_URL}/client/${client_id}/site/${site_id}`;

              let response = await fetch(url, {
                mode: "cors",
                method: "GET",
                withCredentials: true,
                headers: {
                  Authorization: token,
                  "Access-Control-Allow-Origin": "*",
                  "Content-Type": "application/json; charset=utf-8",
                },
              });

              let responseData = await response.json();

              if (response.ok) {
                return responseData.data;
              } else {
                console.log(response.message);
              }
            } catch (error) {
              console.log(error);
            }
          });

          const fetchedSites = await Promise.all(pArray);

          if (componentMounted.current) {
            setSites(fetchedSites);
            setActiveSite(fetchedSites[0].id);

            if (!default_site_id) {
              localStorage.setItem("default_site_id", `${fetchedSites[0].id}`);
            }
          }
        } else {
          ToastUtil.error(
            "You have not been assigned to any site. Please contact Administrator."
          );
        }
      } else {
        ToastUtil.error("User is undefined");
      }
    };

    const fetchSSO = async () => {
      try {
        const response = await getSSOAuthDetailsByToken(sso_token);
        if (componentMounted.current) {
          response && setSsoData(response);
        }
      } catch (error) {
        console.log(error);
      }
    };

    sso_token && fetchSSO();
    fetchClient();
    fetchSites();
    return () => {
      // This code runs when component is unmounted
      componentMounted.current = false; // set it to false when we leave the page
    };
  }, []);

  const refreshToken = async (link) => {
    const response = await getRefreshToken(sso_token);

    response && localStorage.setItem("sso_token", response.token);

    setTimeout(() => {
      setSsoRefreshTokenModal(false);
      window.open(`${link}?ssoid=${response.token}`, "_blank");
    }, 2000);
  };

  const closeModal = () => {
    setSsoRefreshTokenModal(false);
  };

  let statefulChildren = React.Children.map(children, (child) => {
    return React.cloneElement(child, {
      client,
      sites,
      activeSite,
      setActiveSite,
    });
  });

  return (
    <div id="outer-container">
      <Modal
        ariaHideApp={false}
        isOpen={ssoRefreshTokenModal}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        style={{
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
          },
        }}
      >
        <Typography
          style={{
            textAlign: "center",
            fontSize: "14px",
          }}
        >
          Loading, Please wait...
        </Typography>
      </Modal>
      <Sidebar
        pageWrapId={"page-wrap"}
        outerContainerId={"outer-container"}
        isOpen={sidebarActive}
        items={sidebarItems}
        setActiveSidebar={setSidebarActive}
        setSsoRefreshTokenModal={setSsoRefreshTokenModal}
        refreshToken={refreshToken}
      />

      <main id="page-wrap">
        <Navbar
          client={client}
          sites={sites}
          activeSite={activeSite}
          setActiveSite={setActiveSite}
          sidebarToggler={sidebarToggleHandler}
        />
        {statefulChildren}
      </main>
    </div>
  );
};

export default Layout;
